import 'react-datepicker/dist/react-datepicker.css';
import { EventFeed } from '@/components/event-feed';
import { useProjects } from '@/hooks/use-projects';
// import { FilterDialogButton } from '@/components/filter-dialog-button';
import { useFilters } from '@/hooks/use-filters';
import { createFileRoute } from '@tanstack/react-router';
import { infiniteEventsOptions } from '@/hooks/query-options';
import { PageHeader } from '@/components/page-header';
import { PageContent } from '@/components/page-content';

export const Route = createFileRoute('/_auth/_side-layout/events')({
  component: Events,
  loader: ({ context }) => {
    const projectId = context.projectId;
    const filterGroups = [{ filters: [] }];
    const selectedEvent = null;
    if (!projectId) {
      return;
    }
    context.queryClient.prefetchInfiniteQuery(
      infiniteEventsOptions({
        projectId,
        filterGroups,
        selectedEvent,
      }),
    );
  },
});

function Events() {
  const { projectId } = useProjects();
  const { filterGroups } = useFilters();

  return (
    <>
      <PageHeader title="Feed" description="Real-time stream of events from your project." />
      <PageContent>
        <EventFeed key={projectId!} {...{ projectId: projectId!, filterGroups }} />
      </PageContent>
    </>
  );
}
